// import { useEffect } from 'react';
// import ReactDOM from 'react-dom';
// import { BrowserRouter, Route, Switch, Link } from 'react-router-dom';
import MicroApp from '@/components/micro-app';
import type { History } from 'history';
import _connectHistory from '@/history/connect-history';
import env from '@/env';
import { useCallback, useEffect, useRef } from 'react';
import { data as dataJump } from '@/pages/activity-manage/merchants/venue-detail/constants/index';
import { useHistory } from 'react-router-dom';

export default function Ph() {
  const history = useHistory();
  const unConnectHistory = useRef<() => void>();

  const connectHistory = useCallback(
    (targetHistory: History) => {
      unConnectHistory.current = _connectHistory(history, targetHistory, { include: '/ph/' });
    },
    [history]
  );

  useEffect(() => {
    return () => unConnectHistory.current && unConnectHistory.current();
  }, [history]);

  return (
    <MicroApp
      data={{
        basename: '/ph',
        connectHistory,
        jumpUserSetting: dataJump.jumpUserSetting,
        jumpNewCheckProcess: dataJump.jumpNewCheckProcess,
      }}
      url={env.MC_DOMAIN + '/phActivity'}
      name="phManage"
    />
  );
}
